<template>
	<div class="level">
		<div class="level_top">会员专区</div>
		<div class="level_type">
			<div class="level_type_line" :class="'level_type_lines'+[index]" v-for="(item,index) in TzItem" @click="details(item.id,item.cate_name)">
				<div class="level_type_line_top am-cf">
					<img class="am-fl" :src="item.pic" />
					<span class="am-fl">{{item.cate_name}}</span>
					<!-- <button class="am-fr">购买会员</button> -->
				</div>
				<div class="level_type_line_middle">
					
					<div class="level_type_line_middle_block">
						<p class="">套餐价格</p>
						<p class="">{{item.remarks}} USD</p>
					</div>
				</div>
				<div class="level_type_line_bottom">
					<div class="level_type_line_middle_block">套餐包含：</div>
					<div class="level_type_line_middle_block">
						<p class="">{{item.cate_desc}}</p>
					</div>
				</div>
			</div>
		<!-- 	<div class="level_type_line" style="background-color: rgb(130,194,221);">
				<div class="level_type_line_top am-cf">
					<img class="am-fl" src="../../assets/images/hh3.png" />
					<span class="am-fl">vip中级会员</span>
					<button class="am-fr">购买会员</button>
				</div>
				<div class="level_type_line_middle">
					<div class="level_type_line_middle_block">
						<p class="">套餐价格</p>
						<p class="">1000.0 USD</p>
					</div>
					<div class="level_type_line_middle_block">
						<p class="">套餐价格</p>
						<p class="">1000.0 USD</p>
					</div>
					<div class="level_type_line_middle_block">套餐包含：</div>
				</div>
				<div class="level_type_line_bottom">
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×1</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×2</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×3</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×4</p>
					</div>
				</div>
			</div>
			<div class="level_type_line" style="background-color: rgb(185,220,116);">
				<div class="level_type_line_top am-cf">
					<img class="am-fl" src="../../assets/images/hh4.png" />
					<span class="am-fl">vip高级会员</span>
					<button class="am-fr">购买会员</button>
				</div>
				<div class="level_type_line_middle">
					<div class="level_type_line_middle_block">
						<p class="">套餐价格</p>
						<p class="">1000.0 USD</p>
					</div>
					<div class="level_type_line_middle_block">
						<p class="">套餐价格</p>
						<p class="">1000.0 USD</p>
					</div>
					<div class="level_type_line_middle_block">套餐包含：</div>
				</div>
				<div class="level_type_line_bottom">
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×1</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×2</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×3</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×4</p>
					</div>
				</div>
			</div>
			<div class="level_type_line" style="background-color: rgb(234,190,101);">
				<div class="level_type_line_top am-cf">
					<img class="am-fl" src="../../assets/images/hh1.png" />
					<span class="am-fl">vip尊享会员</span>
					<button class="am-fr">购买会员</button>
				</div>
				<div class="level_type_line_middle">
					<div class="level_type_line_middle_block">
						<p class="">套餐价格</p>
						<p class="">1000.0 USD</p>
					</div>
					<div class="level_type_line_middle_block">
						<p class="">套餐价格</p>
						<p class="">1000.0 USD</p>
					</div>
					<div class="level_type_line_middle_block">套餐包含：</div>
				</div>
				<div class="level_type_line_bottom">
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×1</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×2</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×3</p>
					</div>
					<div class="level_type_line_bottom_block">
						<img src="../../assets/images/shop-details-bg.jpg" />
						<p class="">×4</p>
					</div>
				</div>
			</div>
		 -->
		</div>
		<div class="level_trip">
			<p class="">温馨提示：</p>
			<p class="">1、选择会员套餐后，将与会员账号绑定。</p>
			<p class="">2、会员套餐一经售出概不退换，可升级。</p>
		</div>
	</div>
</template>
<script>
	import { getblock } from "@api/public";
	export default {
		data: function() {
			return {
				TzItem:'',
			};
		},
		mounted: function() {
			this.getTzItem()
		},
		methods: {
			// 初始化获取投资栏目
			getTzItem(){
				 getblock({
					 pid:1
				 })
				 .then((res)=>{
					this.TzItem = res.data 
				 })
			},
			// 进入商品列表
			details(uid,Tzname){
				 this.$router.push({
					 path:'/goods_list?id='+uid+'&title='+Tzname
				 })
			},
		},
	};
</script>

<style scoped>
	.level {
		/* width: 100%; */
		padding: 0px 15px 30px 15px;
	}

	.level_top {
		width: 100%;
		font-size: 16px;
		color: #333;
		text-align: center;
		line-height: 35px;
	}

	.level_type {
		width: 100%;
	}
	.level_type_lines0{
		background-color: rgb(233,236,157);
	}
	.level_type_lines1{
		background-color: rgb(130,194,221);
	}
	.level_type_lines2{
		background-color: rgb(185,220,116);
	}
	.level_type_lines3{
		background-color: rgb(234,190,101);
	}
	.level_type_line {
		padding: 10px;
		border-radius: 8px;
		margin-top: 15px;
		width: 100%;
		height: 200px;
		background-image: url('../../assets/images/b1.png');
		background-size: 35%;
		background-position-x: 93%;
		background-position-y: 60%;
		background-repeat: no-repeat;
	}

	.level_type_line_top {
		width: 100%;
		border-bottom: 1px solid #bbbbbb;
		line-height: 35px;
	}

	.level_type_line_top img {
		width: 30px;
	}

	.level_type_line_top span {
		font-size: 20px;
		font-family: cursive;
		font-weight: 600;
		margin-left:12px;
	}

	.level_type_line_top button {
		background-color: rgb(65, 68, 76);
		border-radius: 8px 0px 0px 8px;
		color: #fff;
		padding: 6px 12px;
	}

	.level_type_line_middle {
		display: flex;
		align-items: center;
		padding: 10px 5px;
		border-bottom: 1px solid #bbbbbb;
	}

	.level_type_line_middle_block {
		padding: 8px;
		font-size: 17px;
		font-family: fangsong;
		color: #000000;
	}

	.level_type_line_middle_block:last-child {
		font-weight: bold;
	}

	.level_type_line_bottom {
		display: flex;
		align-items: center;
		padding: 10px 15px;
	}

	.level_type_line_bottom_block {
		margin-right: 8px;
	}

	.level_type_line_bottom_block img {
		width: 40px;
	}

	.level_type_line_bottom_block p {
		text-align: center;
	}

	.level_trip {
		margin-top: 30px;
		font-size: 16px;
		font-family: cursive;
		font-weight: bold;
		line-height: 30px;
	}
</style>

